/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable arrow-body-style */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-continue */
import React, { useState, useEffect, useCallback, useMemo } from "react";
import {
  makeStyles,
  List,
  ListItemIcon,
  ListItem,
  ListItemText,
  Collapse,
  Typography,
  Divider,
  Switch,
  Grid,
  IconButton,
  TextField,
  createTheme,
  Tooltip,
  Container,
  Popper,
  Box,
  ClickAwayListener,
  styled,
  SwitchProps,
  CircularProgress,
} from "@material-ui/core";
import {
  ExpandLess,
  ExpandMore,
  FiberManualRecord as Circle,
  RemoveCircle,
  ChatBubble,
  Timer,
  Edit,
  PanTool,
  PeopleAlt,
  Phone,
  Public,
  Language,
  Done,
  Group,
} from "@material-ui/icons";
// import { red as RedColor } from "@material-ui/core/colors";
import { v4 as uuidv4 } from "uuid";
// import { SQSClient, SendMessageCommand } from "@aws-sdk/client-sqs";
// import { fromCognitoIdentityPool } from "@aws-sdk/credential-provider-cognito-identity";
// import { CognitoIdentityClient } from "@aws-sdk/client-cognito-identity";
// import { Map as ImmutableMap } from "immutable";
import style from "./styles/Profile.module.css"
import EXicon from './icons/EX.png'
import CXicon from './icons/CX.png';
import { CXAgent } from "./CxDashboard";

import { deleteCookie } from "./NEW/Auth";

import { SyncPresenceConfig, syncPresenceCustom, syncPresenceRegular } from "./Profile/utilites/syncPresenceStatuses";
import usePresenceManager from "./Profile/hooks/usePresenceManager";
import ExPresence, { StatusPresentation }  from "./Profile/components/ExPresence";
import { useLightStyles, useDarkStyles } from "./Profile/hooks/useStyles";

import {formatDuration, formatDailyDuration, formatApproxDuration} from "./User";

/* JOHN'S NOTE: I've moved a few things into the /Profile folder to reduce clutter here. */

const DEFAULT_GLOBALS = [
  "<None>",
  "Out of office",
  "In the office",
  "In a meeting",
  "Out sick",
  "Working remotely",
  "Vacationing",
  "Travelling",
];

const IOSSwitch = styled((props: SwitchProps) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: '#0684bd',
        opacity: 1,
        border: 0,
        // ...theme.applyStyles('dark', {
        //   backgroundColor: '#2ECA45',
        // }),
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5,
      },
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: '#33cf4d',
      border: '6px solid #fff',
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color: theme.palette.grey[100],
      // ...theme.applyStyles('dark', {
      //   color: theme.palette.grey[600],
      // }),
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: 0.7,
      // ...theme.applyStyles('dark', {
      //   opacity: 0.3,
      // }),
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 22,
    height: 22,
  },
  '& .MuiSwitch-track': {
    borderRadius: 26 / 2,
    backgroundColor: '#E9E9EA',
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
    // ...theme.applyStyles('dark', {
    //   backgroundColor: '#39393D',
    // }),
  },
}));

// Moved useLightStyle and useDarkStyles to /Profile/hooks/useStyles.ts

const green = "#00b160";
const red = "#ff4e4e";
const yellow = "#f7b500";
const gray = "#9c9c9c";
const blue = "#1e90ff";

export const colorRenderer = (status: string, late?: boolean): string => {
  if (status === undefined || status.startsWith("AVL")) return green;
  if (status.startsWith("DND") && late) return blue;
  if (status.startsWith("DND") || status.startsWith("BSY")) return red;
  if (status.startsWith("INV")) return gray;
  return "green"
}

const cxStatusColorRenderer = (status: string): string => {
  if (status === "AVAILABLE") return green;
  if (status === "TRAINING" || status === "WORKING") return yellow;
  if ( status === "ENGAGED" ||
    status === "BREAK-AFTER-CALL" ||
    status === "TRANSITION" ||
    status === "PENDING-DISPOSITION" ||
    status === "RNA-STATE" ||
    status === "TRAINING" ||
    status === "WORKING") return "red";
    if (status === "OFF-LINE" ||
      status === "UNKNOWN" ||
      status === "AWAY" ||
      status === "LUNCH" ||
      status === "ON-BREAK"|| 
      status === undefined
    ) return gray;
    return gray;

}
export const dotRenderer = (user: any) => {//
  if ( user.display === undefined || user.display.startsWith("AVL")) {
    return (
      <Circle
        style={{ color: green, fontSize: "1.2rem", marginRight: 3 }}
        aria-label="Available icon"
        aria-hidden={false}
        role="img"
      />
    );
  }
  if (user.display.startsWith("DND")) {
    if (user.display !== "DND:LATE"){
      return (
        <RemoveCircle
          aria-label="Do not disturb icon"
          aria-hidden={false}
          role="img"
          style={{ color: red, fontSize: "1.2rem", marginRight: 3 }}
        />
      );
    }

      return (
        <Circle
          style={{ color: blue, fontSize: "1.2rem", marginRight: 3  }}
          aria-label="Late icon"
          aria-hidden={false}
          role="img"
        />
      );
  }

  if (user.display.startsWith("INV")) {
    return (
      <Circle
        style={{ color: gray, fontSize: "1.2rem", marginRight: 3  }}
        aria-label="Invisible icon"
        aria-hidden={false}
        role="img"
      />
    );
  }

  if (user.display.startsWith("BSY")) {
    return (
      <Circle
        style={{ color: red, fontSize: "1.2rem", marginRight: 3  }}
        aria-label="Busy icon"
        aria-hidden={false}
        role="img"
      />
    );
  }
  return "";
}

const CxDotRenderer = ({userCX, mode, classes} : {classes: any, userCX: any, mode: string}) => {
  return (
    <>
    {(() => {
            if (userCX.agentState === undefined) {
              return "";
            }
            if (userCX.agentState === "AVAILABLE") {
              return (
        
                  <Circle
                    style={{
                      color: green,
                      fontSize: "1.2rem", 
                      marginRight: 3, 
                      marginLeft: 10
                    }}
                    aria-label="Available icon"
                    aria-hidden={false}
                    role="img"
                  />
              
              );
            }
            if (
              userCX.agentState === "TRAINING" ||
              userCX.agentState === "WORKING"
            )
              return (
           
                  <Circle
                    style={{
                      color: yellow,
                      fontSize: "1.2rem", 
                      marginRight: 3,
                      marginLeft: 10
                    }}
                    aria-label="busy icon"
                    aria-hidden={false}
                    role="img"
                  />
             
              );
            if (
              userCX.agentState === "ENGAGED" ||
              userCX.agentState === "BREAK-AFTER-CALL" ||
              userCX.agentState === "TRANSITION" ||
              userCX.agentState === "PENDING-DISPOSITION" ||
              userCX.agentState === "RNA-STATE" ||
              userCX.agentState === "TRAINING" ||
              userCX.agentState === "WORKING"
            ) {
              return (
      
                  <Circle
                    style={{
                      color: red,
                      fontSize: "1.2rem", 
                      marginRight: 3,
                      marginLeft: 10
                    }}
                    aria-label="Busy icon"
                    aria-hidden={false}
                    role="img"
                  />
               
              );
            }
  
            if (
              userCX.agentState === "OFF-LINE" ||
              userCX.agentState === "UNKNOWN" ||
              userCX.agentState === "AWAY" ||
              userCX.agentState === "LUNCH" ||
              userCX.agentState === "ON-BREAK"|| 
              userCX.agentState === undefined
            ) {
              return (
            
                  <Circle
                    style={{
                      color: gray,
                      fontSize: "1.2rem", 
                      marginRight: 3,
                      marginLeft: 10
                    }}
                    aria-label="Invisible icon"
                    aria-hidden={false}
                    role="img"
                  />
                
              );
            }
  
            return "";
          })()}
    <span style={{color: cxStatusColorRenderer(userCX.agentState)}}>{userCX.agentState}</span>
  </>
  )
}

function Profile({
  origin,
  organizationId,
  rcId,
  tables,
  historicalQueues,
  timer,
  setTimer,
  mode,
  rules = [],
  forwardAddress,
  idToken,
  hasInvisibleCallControl,
  presenceQueue,
  hasDispositionTab,
  isAdmin,
  showHandRaise,
  myId,
  apiUrl,
  cxAgents,
  rcAccessToken,
  user,
  legacyUI,
  hasCX,
  lateTimer,
  setLateTimer,
  elapsedTime
}: {
  legacyUI: boolean;
  user: any;
  historicalQueues: any;
  origin: string;
  organizationId: string;
  rcId: string;
  tables: any[];
  timer: { duration: string; id: string } | undefined;
  setTimer: any;
  mode: string;
  rules: any[];
  forwardAddress: string;
  idToken: string;
  hasInvisibleCallControl: boolean;
  presenceQueue: boolean | undefined;
  hasDispositionTab: boolean;
  isAdmin: boolean;
  showHandRaise: boolean;
  myId: any;
  apiUrl: string;
  // eslint-disable-next-line
  cxAgents?: CXAgent[];
  rcAccessToken: string;
  hasCX: boolean;
  lateTimer: { duration: string; id: string } | undefined;
  setLateTimer: any;
  elapsedTime: string;
}) {
  const [availableExpand, setAvailableExpand] = useState<boolean>(false);
  const [busyExpand, setBusyExpand] = useState<boolean>(false);
  const [dndExpand, setDndExpand] = useState<boolean>(false);
  const [invisibleExpand, setInvisibleExpand] = useState<boolean>(false);
  const [globalExpand, setGlobalExpand] = useState<boolean>(false);
  const [table, setTable] = useState<any>();
  const [editStatus, setEditStatus] = useState<boolean | undefined>(undefined);
  const [availableEdit, setAvailableEdit] = useState<boolean | undefined>(
    undefined
  );
  const [customAvailable, setCustomAvailable] = useState<string>("[custom]");
  const [busyEdit, setBusyEdit] = useState<boolean | undefined>(undefined);
  const [customBusy, setCustomBusy] = useState<string>("[custom]");
  const [dndEdit, setDndEdit] = useState<boolean | undefined>(undefined);
  const [customDnd, setCustomDnd] = useState<string>("[custom]");
  const [invisibleEdit, setInvisibleEdit] = useState<boolean | undefined>(
    undefined
  );
  const [customInvisible, setCustomInvisible] = useState<string>("[custom]");
  const [tempStatus, setTempStatus] = useState<string>("");
  const [handRaised, setHandRaised] = useState<boolean>(false);
  const [color, setColor] = useState<string>("inherit");
  const [userDetail, setUserDetail] = useState<boolean>(false);
  const classes = mode === "dark" ? useDarkStyles() : useLightStyles();
  const [globalStatuses, setGlobalStatuses] = useState<Array<string>>();
  const [hideEdit, setHideEdit] = useState<boolean>(true);
  const [queuePresenceOpen, setQueuePresenceOpen] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [open, setOpen] = React.useState(false);
  const [cxUser, setCxUser] = useState<undefined | CXAgent>(undefined)
  const [profileTab, setProfileTab] = useState<'user-presence' |  "queue-presence">("user-presence")
  const [acceptQueueLoading, setAcceptQueueLoading] = useState<boolean>(false);

  const [queueLoading, setQueueLoading] = useState<Map<string, boolean>>(
    () => new Map<string, boolean>()
  );


  const [timeElapsed, setTimeElapsed] = useState<string | number | undefined>();
  const [timeElapsedCX, setTimeElapsedCX] = useState<string | number | undefined>();
  const [currentTime, setCurrentTime] = useState<Date>(new Date());

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  const getTimeDifference = () => {
    if (!user?.messageTimestamp && !cxUser?.stateTimestamp) return undefined;

    const lastUpdate = new Date(user.messageTimestamp || 0);
    const lastUpdateCX = new Date(cxUser?.stateTimestamp || 0);

    return {
      differenceTime: Math.floor((currentTime.getTime() - lastUpdate.getTime()) / 1000),
      differenceTimeCX: Math.floor((currentTime.getTime() - lastUpdateCX.getTime()) / 1000)
    };
  };

  const timeDifference = getTimeDifference();

  // Memoization for approximate values
  const approxTimeDifference = useMemo(() => {
    if (!timeDifference) return {approxTime: undefined, approxTimeCX: undefined};

    // Only update approx values when they change (Minute, Hour, Day)
    return {
      approxTime: formatApproxDuration(timeDifference.differenceTime),
      approxTimeCX: formatApproxDuration(timeDifference.differenceTimeCX),
    };
  }, [
    timeDifference?.differenceTime ? Math.floor(timeDifference?.differenceTime / 60) : 0,
    timeDifference?.differenceTimeCX ? Math.floor(timeDifference?.differenceTimeCX / 60) : 0
  ]);

  useEffect(() => {
    if (!timeDifference) return;
    if (elapsedTime === "full") {
      // Format elapsedTime --> 24hr cycle
      setTimeElapsed(formatDuration(timeDifference.differenceTime));
      setTimeElapsedCX(formatDuration(timeDifference.differenceTimeCX));
      return;
    }
    // Use memoized values for approximate time
    if (elapsedTime === "approximate") {
      setTimeElapsed(approxTimeDifference.approxTime);
      setTimeElapsedCX(approxTimeDifference.approxTimeCX);
    }
    if (elapsedTime === "daily") {
      // Format elapsedTime --> Reset at midnight
      setTimeElapsed(formatDailyDuration(timeDifference.differenceTime));
      setTimeElapsedCX(formatDailyDuration(timeDifference.differenceTimeCX));
    }
  }, [currentTime, timeDifference, approxTimeDifference, elapsedTime])

  useEffect(()=>{setAcceptQueueLoading(false)}, [user.lastDndStatus]);

  // statusPresentation is now managed by usePresenceManager hook
  
  useEffect(() => {
    // For tracking loading spinners in queue presences.
    if (queueLoading.size === 0) return;

    setQueueLoading((prev) => {
      const next = new Map(prev);
      for (const [id, expectedValue] of prev.entries()) {
        const queue = historicalQueues.get(id);
        if (!queue) {
          next.delete(id);
          continue;
        }

        const currentValue = queue.users.find(
          (u: any) => u.id === user.id
        ).acceptCurrentQueueCalls;

        if (currentValue === expectedValue) {
          next.delete(id);
        }
      }
      return next;
    });
  }, [historicalQueues, user.id]);
  useEffect(()=>{setAcceptQueueLoading(false)}, [user.lastDndStatus]); // For tracking loading spinner on queue tab.
  
  useEffect(() => {
    setCxUser(() => {
      return  cxAgents?.find((agent) => agent.rcUserId === user.id)
    })
  }, [cxAgents])

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    setOpen((previousOpen) => !previousOpen);
  };

  useEffect(()=>{
    console.log("detected user with a late property: ", user);
        console.log("User.timerInfo:", user.timerInfo);
  }, [user.late])


  const canBeOpen = open && Boolean(anchorEl);
  const id = canBeOpen ? 'transition-popper' : undefined;


  document.body.className = classes.body;

  const reactAppUrl  = process.env.REACT_APP_API_URL || "";

  const apiConfig: SyncPresenceConfig = {
    rcId,
    rcAccessToken,
    idToken,
    organizationId,
    apiUrl,
    otherApiUrl: reactAppUrl
  }

  // Use the centralized presence manager
  const { statusPresentation, changeRegularPresence, changeCustomPresence } = usePresenceManager({
    apiConfig,
    user
  });

  useEffect(() => {
    (async () => {
      const items = (await fetch(
        forwardAddress.replace("/shadow-agent", "/globals"),
        {
          method: "get",
          headers: {
            authorization: idToken,
          },
        }
      ).then((res) => res.json())) as Array<{ name: string }>;

      if (items.length) {
        setGlobalStatuses(items.map((item) => item.name));
        setHideEdit(
          items.find((item) => item.name === "[custom]") === undefined
        );
      } else {
        setGlobalStatuses(DEFAULT_GLOBALS);
      }
    })();
  }, [forwardAddress, idToken]);

  useEffect(() => {
    // console.log("useEffect triggered. editStatus:", editStatus);
  
    if (editStatus === undefined) {
      return;
    }
  
    const eventTime = new Date().toISOString();
    const uuid = uuidv4();
  
    const update = async () => {
      // console.log("Updating presence. New status:", tempStatus);
  
      // Tell RC
      window.parent.postMessage(
        JSON.stringify({
          event: "flash-message",
          message: `MSG:${tempStatus}`,
          id: rcId,
        }),
        origin
      );

      const res = await fetch(`${process.env.REACT_APP_API_URL}/flash`, {
        method: "POST",
        body: JSON.stringify({
          message: `MSG:${tempStatus}`,
          userStatus: "Available",
          id: rcId,
          token: rcAccessToken,
        }),
        headers: {
          authorization: idToken || "",
        },
      });
  
      // console.log("Response status:", res.status);
  
      if (!res.ok) {
        // console.error("API error. Response:", await res.text());
        return;
      }
  
      // Tell SA
      const saResponse = await fetch(apiUrl, {
        method: "post",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          event: `/restapi/v1.0/account/${organizationId}/extension/${rcId}/presence`,
          body: {
            status: tempStatus,
          },
          send: true,
        }),
      });
  
      // console.log("SA Response Status:", saResponse.status);
      
      // if (!saResponse.ok) {
      //   // console.error("SA API error. Response:", await saResponse.text());
      //   return;
      // }
  
      // console.log("Presence updated successfully!");
  
      // if (!editStatus) {
      //   console.log("Update completed, not calling update() again.");
      // }
    };
    
    // if (hasDispositionTab) {
    //   try {
    //     const client = getSQSClient();
    //     const command = new SendMessageCommand({
    //       MessageBody: JSON.stringify({
    //         prefix: "MSG",
    //         accountId: organizationId,
    //         extensionId: rcId,
    //         time: eventTime,
    //         code: "Global",
    //         message: `MSG:${tempStatus}`,
    //         id: uuid,
    //       }),
    //       QueueUrl:
    //         "https://sqs.us-east-1.amazonaws.com/272252618507/disposition-codes",
    //     });

    //     await client.send(command);
    //   } catch (err) {
    //     console.log(err);
    //   }
    // }

    if (!editStatus) {
      update();
    }
  }, [editStatus, tempStatus, hasDispositionTab]); 
  

  const handleGlobalChange = useCallback(
    async (myGlobal: string) => {
      // tell RC
      // window.parent.postMessage(
      //   JSON.stringify({
      //     event: "flash-message",
      //     message: `MSG:${myGlobal}`,
      //     id: rcId,
      //   }),
      //   origin
      // );
      const res = await fetch(`${process.env.REACT_APP_API_URL}/flash`, {
        method: "POST",
        body: JSON.stringify({
          message: `MSG:${myGlobal}`,
          id: rcId,
          token: rcAccessToken,
        }),
        headers: {
          authorization: idToken || "",
        },
      });
      // tell SA
      if (res.ok) {
        await fetch(apiUrl, {
          method: "post",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            event: `/restapi/v1.0/account/${organizationId}/extension/${rcId}/presence`,
            body: {
              status: myGlobal,
            },
            send: true,
          }),
        });

        // send message to 'disposition-codes' queue
        const eventTime = new Date().toISOString();
        const uuid = uuidv4();

        // if (hasDispositionTab) {
        //   try {
        //     const client = getSQSClient();
        //     const command = new SendMessageCommand({
        //       MessageBody: JSON.stringify({
        //         prefix: "MSG",
        //         accountId: organizationId,
        //         extensionId: rcId,
        //         time: eventTime,
        //         code: "Global",
        //         message: `MSG:${myGlobal}`,
        //         id: uuid,
        //       }),
        //       QueueUrl:
        //         "https://sqs.us-east-1.amazonaws.com/272252618507/disposition-codes",
        //     });

        //     await client.send(command);
        //   } catch (err) {
        //     console.log(err);
        //   }
        // }
      }
      setGlobalExpand(false)
    },
    [hasDispositionTab]
  );

  const handleAcceptCallsClick = useCallback(
    async (queue: any) => {

      console.log("queue: ", queue);
      if (user.lastDndStatus === "DoNotAcceptAnyCalls") {
        return;
      }
      const current = queue.users.find((u: any) => u.id === user.id)
        .acceptCurrentQueueCalls;
      const expected = !current;

      // mark it pending
      setQueueLoading((prev) => {
        const next = new Map(prev);
        next.set(queue.id, expected);
        return next;
      });
      /* const newPrefix = queue.users.find(
        (queueUser: any) => queueUser.id === user.id
      ).acceptCurrentQueueCalls
        ? "QLO"
        : "QLI";

      const newCode = queue.users.find(
        (queueUser: any) => queueUser.id === user.id
      ).acceptCurrentQueueCalls
        ? "QueueSignOut"
        : "QueueSignIn"; */

      const res = await fetch(
        `${apiUrl.replace("/site/main-site", "")}/client/queue/${
          queue.id
        }/presence/${rcId}`,
        {
          method: "PUT", // *GET, POST, PUT, DELETE, etc.
          headers: {
            "Content-Type": "application/json",
            Authorization: idToken,
          },
          body: JSON.stringify({
            token: rcAccessToken,
            value: !queue.users.find(
              (queueUser: any) => queueUser.id === user.id
            ).acceptCurrentQueueCalls,
          }), // body data type must match "Content-Type" header
        }
      );
      /* const eventTime = new Date().toISOString();
      const uuid = uuidv4();

      // send message to 'disposition-codes' queue
      if (hasDispositionTab) {
        try {
          const client = getSQSClient();
          const command = new SendMessageCommand({
            MessageBody: JSON.stringify({
              prefix: newPrefix,
              queueId: queue.id,
              accountId: organizationId,
              extensionId: rcId,
              time: eventTime,
              code: newCode,
              message: `${newPrefix}:${queue.id}`,
              id: uuid,
            }),
            QueueUrl:
              "https://sqs.us-east-1.amazonaws.com/272252618507/disposition-codes",
          });

          await client.send(command);
        } catch (err) {
          console.log(err);
        }
      } */
    },
    [user, hasDispositionTab]
  );

  useEffect(() => {
    if (availableEdit === undefined) {
      return;
    }

    const update = async () => {
      // tell RC
      // window.parent.postMessage(
      //   JSON.stringify({
      //     event: "flash-message",
      //     message: `AVL:${customAvailable}`,
      //     id: rcId,
      //     timer: false,
      //     dndStatus:
      //       user.lastDndStatus === "DoNotAcceptAnyCalls"
      //         ? "TakeAllCalls"
      //         : undefined,
      //     userStatus: "Available",
      //   }),
      //   origin
      // );
      const res = await fetch(`${process.env.REACT_APP_API_URL}/flash`, {
        method: "POST",
        body: JSON.stringify({
          dndStatus:
            user.lastDndStatus === "DoNotAcceptAnyCalls"
              ? "TakeAllCalls"
              : undefined,
          userStatus: "Available",
          message: `AVL:${customAvailable}`,
          id: rcId,
          token: rcAccessToken,
        }),
        headers: {
          authorization: idToken || "",
        },
      });
      // tell SA
      if (res.ok) {
        await fetch(apiUrl, {
          method: "post",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            event: `/restapi/v1.0/account/${organizationId}/extension/${rcId}/presence`,
            body: {
              dndStatus:
                user.lastDndStatus === "DoNotAcceptAnyCalls"
                  ? "TakeAllCalls"
                  : undefined,
              presenceStatus: "Available",
              message: "AVL:[custom]",
              custom: `AVL:${customAvailable}`,
            },
            send: true,
          }),
        });
        if (!availableEdit) {
          update();
        }
      }
    };
  }, [availableEdit]);

  useEffect(() => {
    if (busyEdit === undefined) {
      return;
    }

    const update = async () => {
      // tell RC
      // window.parent.postMessage(
      //   JSON.stringify({
      //     event: "flash-message",
      //     message: `BSY:${customBusy}`,
      //     id: rcId,
      //     timer: false,
      //     dndStatus:
      //       user.lastDndStatus === "DoNotAcceptAnyCalls"
      //         ? "TakeAllCalls"
      //         : undefined,
      //     userStatus: "Busy",
      //   }),
      //   origin
      // );
      const res = await fetch(`${process.env.REACT_APP_API_URL}/flash`, {
        method: "POST",
        body: JSON.stringify({
          dndStatus:
            user.lastDndStatus === "DoNotAcceptAnyCalls"
              ? "TakeAllCalls"
              : undefined,
          userStatus: "Busy",
          message: `BSY:${customBusy}`,
          id: rcId,
          token: rcAccessToken,
        }),
        headers: {
          authorization: idToken || "",
        },
      });
      // tell SA
      if (res.ok) {
        await fetch(apiUrl, {
          method: "post",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            event: `/restapi/v1.0/account/${organizationId}/extension/${rcId}/presence`,
            body: {
              dndStatus:
                user.lastDndStatus === "DoNotAcceptAnyCalls"
                  ? "TakeAllCalls"
                  : undefined,
              presenceStatus: "Busy",
              message: "BSY:[custom]",
              custom: `BSY:${customBusy}`,
            },
            send: true,
          }),
        });

        if (!busyEdit) {
          update();
        }
      }
    };
  }, [busyEdit]);

  useEffect(() => {
    if (dndEdit === undefined) {
      return;
    }

    const update = async () => {
      // tell RC
      // window.parent.postMessage(
      //   JSON.stringify({
      //     event: "flash-message",
      //     message: `DND:${customDnd}`,
      //     id: rcId,
      //     timer: false,
      //     dndStatus: "DoNotAcceptAnyCalls",
      //     userStatus: "Busy",
      //   }),
      //   origin
      // );
      const res = await fetch(`${process.env.REACT_APP_API_URL}/flash`, {
        method: "POST",
        body: JSON.stringify({
          dndStatus: "DoNotAcceptAnyCalls",
          userStatus: "Busy",
          message: `DND:${customDnd}`,
          id: rcId,
          token: rcAccessToken,
        }),
        headers: {
          authorization: idToken || "",
        },
      });
      // tell SA
      if (res.ok) {
        await fetch(apiUrl, {
          method: "post",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            event: `/restapi/v1.0/account/${organizationId}/extension/${rcId}/presence`,
            body: {
              dndStatus: "DoNotAcceptAnyCalls",
              presenceStatus: "Busy",
              message: "DND:[custom]",
              custom: `DND:${customDnd}`,
            },
            send: true,
          }),
        });
        if (!dndEdit) {
          update();
        }
      }
    };
  }, [dndEdit]);

  useEffect(() => {
    if (invisibleEdit === undefined) {
      return;
    }

    const update = async () => {
      let dndStatus =
        user.lastDndStatus === "DoNotAcceptAnyCalls"
          ? "TakeAllCalls"
          : undefined;

      if (hasInvisibleCallControl) {
        const { invisibleCallControl: newCallControl } = await fetch(
          forwardAddress.replace("/shadow-agent", `/user/${rcId}`),
          {
            method: "get",
            headers: {
              Authorization: idToken,
            },
          }
        ).then((res) => res.json());
        dndStatus = newCallControl;
      }

      // tell RC
      // window.parent.postMessage(
      //   JSON.stringify({
      //     event: "flash-message",
      //     message: `INV:${customInvisible}`,
      //     id: rcId,
      //     timer: false,
      //     dndStatus,
      //     userStatus: "Offline",
      //   }),
      //   origin
      // );
      const res = await fetch(`${process.env.REACT_APP_API_URL}/flash`, {
        method: "POST",
        body: JSON.stringify({
          dndStatus,
          userStatus: "Offline",
          message: `INV:${customInvisible}`,
          id: rcId,
          token: rcAccessToken,
        }),
        headers: {
          authorization: idToken || "",
        },
      });
      // tell SA
      if (res.ok) {
        await fetch(apiUrl, {
          method: "post",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            event: `/restapi/v1.0/account/${organizationId}/extension/${rcId}/presence`,
            body: {
              dndStatus,
              presenceStatus: "Offline",
              message: "INV:[custom]",
              custom: `INV:${customInvisible}`,
            },
            send: true,
          }),
        });
      }
      if (!invisibleEdit) {
        update();
      }
    };
  }, [invisibleEdit, hasInvisibleCallControl]);

  useEffect(() => {
    if (tables === undefined) {
      return;
    }

    if (rules === undefined) {
      return;
    }

    if (user === undefined) {
      return;
    }

    const testRule = (index = 0): string => {
      if (rules[index] === undefined) {
        return "default";
      }

      const rule = rules[index];

      if (
        rule.categories.reduce((sum: any, re: any) => {
          if (re.category === "Queue") {
            return (
              sum &&
              historicalQueues
                .filter((queue: any) =>
                  queue.users.find((queueUser: any) => queueUser.id === user.id)
                )
                .find((queue: any) =>
                  new RegExp(re.regularExpression).test(queue[re.field])
                )
            );
          }

          if (re.category === "Extension") {
            return sum && new RegExp(re.regularExpression).test(user[re.field]);
          }

          if (re.category === "Department") {
            return (
              sum && new RegExp(re.regularExpression).test(user.department)
            );
          }

          return false;
        }, true)
      ) {
        return rule.id;
      }

      return testRule(index + 1);
    };

    const myTableId = testRule();
    const ruleTable = tables.find((myTable) => myTable.id === myTableId);
    // const orderTable =
    //   ruleTable.order && ruleTable.order.length > 0
    //     ? reorderArray(ruleTable.order, ruleTable.items)
    //     : ruleTable.items;
    const orderTable = ruleTable.items
      .map((item: any) => ({
        ...item,
        order: (ruleTable.order || []).findIndex(
          (theId: any) => theId === item.id
        ),
      }))
      .sort((a: any, b: any) => {
        if (a.order !== -1 && b.order !== -1) {
          return a.order - b.order;
        }

        if (a.order !== -1 && b.order === -1) return 1;
        if (a.order === -1 && b.order !== -1) return -1;

        if (a.id > b.id) {
          return 1;
        }

        return -1;
      });

    setTable(orderTable);
  }, [tables, rules, user, historicalQueues]);

  useEffect(() => {
    if (user.custom === "AVL") {
      setCustomAvailable((user.display || "").substring(4));
    }
    if (user.custom === "BSY") {
      setCustomBusy((user.display || "").substring(4));
    }
    if (user.custom === "DND") {
      setCustomDnd((user.display || "").substring(4));
    }
    if (user.custom === "INV") {
      setCustomInvisible((user.display || "").substring(4));
    }
  }, [user.custom]);

  useEffect(() => {
    if (user.display === undefined) {
      return;
    }
    if (user.display.startsWith("AVL:")) {
      setAvailableExpand(true);
    }
    if (user.display.startsWith("BSY:")) {
      setBusyExpand(true);
    }
    if (user.display.startsWith("DND:")) {
      setDndExpand(true);
    }
    if (user.display.startsWith("INV:")) {
      setInvisibleExpand(true);
    }
  }, [user.display]);

  useEffect(() => {
    if (user.status === undefined) {
      return;
    }

    setTempStatus(user.status);
  }, [user.status]);

  useEffect(() => {
    if (user.emergency === undefined) {
      return;
    }

    setHandRaised(user.emergency || false);
  }, [user.emergency]);

  const raiseHandChange = useCallback(async () => {
    await fetch(apiUrl, {
      method: "post",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        event: `/restapi/v1.0/account/${organizationId}/extension/${rcId}/presence`,
        body: {
          emergency: !handRaised,
          late: user.late || false
        },
      }),
    });
  }, [rcId, isAdmin, apiUrl, handRaised, organizationId]);

  useEffect(() => {
    setColor(mode === "dark" ? "white" : "inherit");
  }, [mode]);

  const lightMode = mode === 'light';



  return !legacyUI ? (
    <Container 
    className={style.profileGridContainer} 
    maxWidth='lg' style={{height:  'calc(100vh - 70px)', paddingTop: 30, borderRadius: 15}}>
      <Grid className={style.profileGridContainerInner} container spacing={4} style={{height: '100%', borderRadius: 15,
        //  border: lightMode ? '1px solid #00000012' : "1px solid #e7e7e714"
         }}>
      {/* LEFT SIDE */}
      <Grid item 
      xs={12} sm={6} lg={4} xl={4} className={style.gridInner} >
      <div className={style.profileContainer}>
        <div className={style.profileContainerTop}>
        <img  aria-label="portrait" alt="Icon" style={{ borderRadius: "50%" , marginTop: 20, width: 175, height: 175}} src={user.uri? `${user.uri}?access_token=${rcAccessToken}`: "./default-user-image.ico"} onError={(e: any) => {e.target.src = "./default-user-image.ico"}}/>
        <h1 className={[style.nameHeader, ' notranslate'].join("")} >{user.firstName} {user.lastName} 
          {/* if an admin and a different users hand is raised */}
          {user.id !== myId && showHandRaise && handRaised && isAdmin && (
            <IconButton size="medium" onClick={raiseHandChange}>
            <PanTool style={{ color: red[500]}}/>
          </IconButton>)}
          {/* if hand is raised on my profile page... */}
          {user.id === myId && showHandRaise && (
          <IconButton size="medium" onClick={raiseHandChange}>
            <PanTool style={{color: handRaised ? "red" : color}} className={handRaised ?  style.handRaised : ""}/>
          </IconButton>)}
        </h1>

        {/* GLOBAL STATUS */}
        <Grid spacing={2}>
          <ListItem disableRipple aria-describedby={id} aria-label="expand status" button onClick={(e) => {handleClick(e); if (editStatus) return; setGlobalExpand(!globalExpand)}} 
          className={[...classes.header, ' notranslate'].join("")}
          style={{background: lightMode ? '#fafafa' : "#3d3f41", borderRadius: 19, marginTop: 5}}
          >
            {/* Globe icon */}
            <ListItemIcon style={ mode === "dark" ? {padding: 12, color: "white", width: 20, maxWidth: 15, minWidth: 15}: { padding: 12, width: 20, maxWidth: 15, minWidth: 15}}>
              <Language style={{ fontSize: "1.2rem", color: '#0684bd', fontWeight: 900 }} />
            </ListItemIcon>
            {/* when editing */}
            {!!editStatus && (
              <input  value={tempStatus} 
              onChange={(event) => {setTempStatus(event.target.value);}} 
              onKeyPress={(event: any) => {
                if (event.key === "Enter") {
                  setEditStatus(!editStatus)
                }}} 
                
                className="notranslate"
                // classes={{ root: [...classes.text, " notranslate"].join("") }} 
                style={ mode === "dark" ? 
                  { color: "white", textAlign: "start", minWidth: 200, marginRight: 5, fontWeight: "bold", fontFamily: 'sans-serif',  border: 0, borderBottom: '1px solid gray', background: "transparent" } : 
                  { color: "#4e4e4e", textAlign: "start", minWidth: 180, marginRight: 5, fontWeight: "bold", fontFamily: 'sans-serif', border: 0, borderBottom: '1px solid gray', background: "transparent" }
                }/>
            )}
            {/* when not editing */}
            {!editStatus && (
              <span style={{color: lightMode ? "#4e4e4e" : "white", paddingLeft: 0, width: '100%', minWidth: 180, textAlign: 'start', fontWeight: "bold", fontFamily: 'sans-serif' }}>{user.status || <span style={{opacity:'0.6'}}>--</span>}</span>
              )}
            {!hideEdit && (
                <IconButton disableFocusRipple disableTouchRipple disableRipple color="primary" component="span" onClick={(event: any) => {event.stopPropagation(); setEditStatus(!editStatus);}}>
                 {
                  !editStatus ? 
                  <Edit style={{ fontSize: "0.7rem" }} /> :
                  <Done style={{ fontSize: "1.2rem"}} />
                 }
                </IconButton>
              )}
            {
              !editStatus && (
                <>
                {globalExpand ? <ExpandLess style={{paddingRight: 12}} /> : <ExpandMore style={{paddingRight: 12}}/>}
                </>
              )
            }
          </ListItem>
        </Grid>
        {/* GLOBAL STATUS DROPDOWN */}
        <Popper modifiers={{flip: {enabled: false},preventOverflow: {enabled: true,boundariesElement: 'scrollParent',}}} id={id} open={globalExpand} anchorEl={anchorEl} placement="bottom" style={{width: 'inherit', }}>
        <ClickAwayListener onClickAway={() => setGlobalExpand(false)}>
          <Box>
          <div className={lightMode ? style.globalButtonContainer : style.globalButtonContainerDark}>
            {globalStatuses?.map((myGlobal) => (
              <button key={myGlobal} type="button" onClick={() => handleGlobalChange(myGlobal)} className={lightMode ? style.globalButton : style.globalButtonDark} >
                <span className="notranslate">{myGlobal}</span>
              </button>
            ))}
          </div>
          </Box>
          </ClickAwayListener>
        </Popper>

        {/* EX PRESENCE */}
        <div className={style.presenceRows}>
                  <ExPresence 
          accountId={organizationId}
          userId={rcId}
          display={user.display}
          cxUser={!!cxUser?.agentState}
          lightMode={lightMode}
          idToken={idToken}
          statusPresentation={statusPresentation}
          timeElapsed={timeElapsed}
          presenceTimerData={user.timerInfo}
          late={user.late}
        />
        </div>
        {/* CX PRESENCE  */}
        {
          (hasCX && cxUser && cxUser.agentState !== undefined) && (

            <div className={style.presenceRows}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                <div style={{display: 'flex', alignItems:'center', justifyContent: (cxUser && cxUser.agentState !== undefined) ? 'start' : 'center'}}>
                  <Tooltip title="CX">
                    <img src={CXicon} alt="CX icon" style={{height: 20, width: 20, filter: lightMode ? 'brightness(50%)' : "invert(1)", marginRight: 4}} />
                  </Tooltip>
                  <CxDotRenderer mode={mode} classes={classes} userCX={cxUser}  />
                </div>
                {cxUser.stateTimestamp && (
                  <div>{timeElapsedCX}</div>
                )}
              </div>
             </div>
            )
        }
        <Divider className={style.divider} style={{width: '100%', marginTop: 15, marginLeft: 4}} />
        </div>
        <div className={style.profileContainerBottom}>
          {/* EX DETAIL */}
           <div className={style.detailsRow}>
            <div className={style.detailsLabel} style={{color: lightMode ? "#a5a5a5" : "#a8a8a8"}}>Email</div>
            <div className={style.detailsTextdiv}>{user?.email ? <span className="notranslate">{user.email}</span> : "-----"}</div>
          </div>
          
          <div className={style.detailsRow}>
            <div className={style.detailsLabel} style={{color: lightMode ? "#a5a5a5" : "#a8a8a8"}}>Title</div>
            <div className={style.detailsTextdiv}>{user?.jobTitle ? <span className="notranslate">{user.jobTitle}</span> : "-----"}</div>
          </div>

          <div className={style.detailsRow}>
            <div className={style.detailsLabel} style={{color: lightMode ? "#a5a5a5" : "#a8a8a8"}}>Department</div>
            <div className={style.detailsTextdiv}>{user?.department ? <span className="notranslate">{user.department}</span> : "-----"}</div>
          </div>

          <div className={style.detailsRow}>
            <div className={style.detailsLabel} style={{color: lightMode ? "#a5a5a5" : "#a8a8a8"}}>Location</div>
            <div className={style.detailsTextdiv}>{user?.location ? <span className="notranslate">{user.location}</span> : "-----"}</div>
          </div>
 
          {/* CX DETAIL */}
        </div>
      </div>
      </Grid>

      {/* RIGHT SIDE */}
      <Grid item className={lightMode ? style.gridRightContainer : style.gridRightContainerDark}
       xs={12} sm={6} lg={8} xl={8} style={{background: lightMode ? '#aaa':"rgb(53 53 53)", 
        // borderLeft: lightMode ?  "1px solid #00000012" :  "1px solid #e7e7e714", 
        borderRadius: "0.5rem"}}>
        <div className={style.gridRightHeader}>
          <button className={ lightMode ? style.gridHeaderButton : style.gridHeaderButtonDark} 
            style={profileTab === "user-presence" ? {background: lightMode ? "white" : "#363535"} : {}} 
            type="button"
            onClick={() => setProfileTab("user-presence")} >
              User Presence
          </button>
          <button className={lightMode ? style.gridHeaderButton : style.gridHeaderButtonDark} 
            style={profileTab === "queue-presence" ? {background: lightMode ? "white" : "#363535"} : {}} 
            type="button" 
            onClick={() => setProfileTab("queue-presence")}>
              Queue Presence
          </button>
        </div>
        <Grid className={lightMode ? style.gridRight : style.gridRightDark} item style={{}}>  
          <List>
           {
            profileTab === "user-presence" && (
              <>

              {/* AVAILABLE PRESENCES */}
              <div className={style.presenceCollapseContainer} style={{marginTop: 30}}>
                <ListItem 
                  aria-label="Expand available" 
                  className={lightMode ? style.presenceDropdown : style.presenceDropdownDark}
                  button 
                  disableRipple
                  onClick={() => setAvailableExpand(!availableExpand)}>
                  <ListItemIcon>
                    <Circle style={{ color: "green" }} />
                  </ListItemIcon>
                  <ListItemText
                    primary="Available"
                  />
                  {availableExpand ? <ExpandLess /> : <ExpandMore />}
                  </ListItem>
                <Collapse in={availableExpand} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    <ListItem
                      aria-label="Select available status"
                      button
                      className={lightMode ? style.presenceSelectable : style.presenceSelectableDark}
                      selected={user.display === "AVL:Available"}
                      disabled={statusPresentation.kind !== "InStatus"}
                      onClick={async () => {
                        // Use centralized presence change with timeout
                        changeRegularPresence("AVL", table.duration);
                      }}
                    >
                      <ListItemText
                        className={classes.innerList}
                        primary="Available"
                      />
                    </ListItem>
                    {table &&
                      table
                        .filter((myTable: any) => myTable.category === "avl")
                        .map((myTable: any, i: number) => (
                          <ListItem
                            key={myTable.id}
                            button
                            className={lightMode ? style.presenceSelectable : style.presenceSelectableDark}
                            selected={
                              myTable.status === "[custom]" ? user.custom === "AVL" : user.display === `AVL:${myTable.status}`
                            }
                            disabled={statusPresentation.kind !== "InStatus"}
                            onClick={async () => {
                              // Use centralized presence change with timeout
                              changeCustomPresence("AVL", myTable, customAvailable);
                            }}
                          >
                            {myTable.duration && (
                              <ListItemIcon style={{ minWidth: 0 }}>
                                <Timer style={{ fontSize: "0.7rem" }} />
                              </ListItemIcon>
                            )}
                            <ListItemText
                              className={[...classes.innerList, " notranslate"].join("")}
                              primary={
                                <div className="notranslate">
                                  {myTable.status !== "[custom]" && (
                                    <span className="notranslate">{myTable.status}</span>
                                  )}
                                  {myTable.status === "[custom]" &&
                                    !availableEdit && (
                                      <span className="notranslate">{customAvailable}</span>
                                    )}
                                  {myTable.status === "[custom]" && availableEdit && (
                                    <TextField
                                      variant="outlined"
                                      autoFocus
                                      className="notranslate"
                                      value={customAvailable}
                                      onChange={(event) => {
                                        setCustomAvailable(
                                          event.target.value
                                            .replace(":", "")
                                            .slice(0, 30)
                                        );
                                      }}
                                      onKeyPress={(event: any) => {
                                        if (event.key === "Enter") {
                                          setAvailableEdit(!availableEdit);
                                        }
                                      }}
                                      hiddenLabel
                                      size="small"
                                      classes={{ root: [...classes.text, ' notranslate'].join("") }}
                                      style={
                                        mode === "dark" ? { color: "white" } : {}
                                      }
                                    />
                                  )}
                                  {myTable.status === "[custom]" && (
                                    <IconButton
                                      color="primary"
                                      component="span"
                                      onClick={(event: any) => {
                                        event.stopPropagation();
                                        setAvailableEdit(!availableEdit);
                                      }}
                                    >
                                      <Edit style={{ fontSize: "0.7rem" }} />
                                    </IconButton>
                                  )}
                                </div>
                              }
                            />
                          </ListItem>
                        ))}
                  </List>
                </Collapse>
              </div>

            {/*  BUSY PRESENCES */}
           <div className={style.presenceCollapseContainer}>
            <ListItem disableRipple button onClick={() => setBusyExpand(!busyExpand)} className={lightMode ? style.presenceDropdown : style.presenceDropdownDark}>
              <ListItemIcon>
                <Circle style={{ color: "red" }} />
              </ListItemIcon>
              <ListItemText
                primary="Busy"
                classes={{ primary: classes.listItemText }}
              />
              {busyExpand ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={busyExpand} timeout="auto" unmountOnExit >
              <List component="div" disablePadding>
                <ListItem disableRipple button selected={user.display === "BSY:Busy"} className={lightMode ? style.presenceSelectable : style.presenceSelectableDark}
                  disabled={statusPresentation.kind !== "InStatus"}
                  onClick={async () => {
                    // Use centralized presence change with timeout
                    changeRegularPresence("BSY", table.duration);
                  }}
                >
                  <ListItemText className={classes.innerList} primary="Busy" />
                </ListItem>
                {table &&
                  table
                    .filter((myTable: any) => myTable.category === "bus")
                    .map((myTable: any) => (
                      <ListItem
                        key={myTable.id}
                        button
                        className={lightMode ? style.presenceSelectable : style.presenceSelectableDark}
                        selected={
                          myTable.status === "[custom]"
                            ? user.custom === "BSY"
                            : user.display === `BSY:${myTable.status}`
                        }
                        disabled={statusPresentation.kind !== "InStatus"}
                        onClick={async () => {
                          // Use centralized presence change with timeout
                          changeCustomPresence("BSY", myTable, customBusy);
                        }}
                      >
                        {myTable.duration && (
                          <ListItemIcon style={{ minWidth: 0 }}>
                            <Timer style={{ fontSize: "0.7rem" }} />
                          </ListItemIcon>
                        )}
                        <ListItemText
                          className={[...classes.innerList, ' notranslate'].join("")}
                          primary={
                            <div className="notranslate">
                              {myTable.status !== "[custom]" && (
                                <span className="notranslate">{myTable.status}</span>
                              )}
                              {myTable.status === "[custom]" && !busyEdit && (
                                <span className="notranslate">{customBusy}</span>
                              )}
                              {myTable.status === "[custom]" && busyEdit && (
                                <TextField
                                  variant="outlined"
                                  autoFocus
                                  value={customBusy}
                                  onChange={(event) => {
                                    setCustomBusy(
                                      event.target.value.replace(":", "")
                                    );
                                  }}
                                  onKeyPress={(event: any) => {
                                    if (event.key === "Enter") {
                                      setBusyEdit(!busyEdit);
                                    }
                                  }}
                                  hiddenLabel
                                  size="small"
                                  classes={{ root: [...classes.text, ' notranslate'].join("") }}
                                  style={
                                    mode === "dark" ? { color: "white" } : {}
                                  }
                                />
                              )}
                              {myTable.status === "[custom]" && (
                                <IconButton
                                  color="primary"
                                  component="span"
                                  onClick={(event: any) => {
                                    event.stopPropagation();
                                    setBusyEdit(!busyEdit);
                                  }}
                                >
                                  <Edit style={{ fontSize: "0.7rem" }} />
                                </IconButton>
                              )}
                            </div>
                          }
                        />
                      </ListItem>
                    ))}
              </List>
            </Collapse>
           </div>

            {/* DND PRESENCES */}
            <div className={style.presenceCollapseContainer}>
            <ListItem disableRipple button onClick={() => setDndExpand(!dndExpand)} className={lightMode ? style.presenceDropdown : style.presenceDropdownDark}>
              <ListItemIcon>
                <RemoveCircle
                  style={{ color: "red", fontSize: "1.2rem", paddingLeft: 2 }}
                />
              </ListItemIcon>
              <ListItemText
                primary="Do not disturb"
                classes={{ primary: classes.listItemText }}
              />
              {dndExpand ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={dndExpand} timeout="auto" unmountOnExit >
              <List component="div" disablePadding>
                <ListItem button className={lightMode ? style.presenceSelectable : style.presenceSelectableDark} selected={user.display === "DND:Do not disturb"}
                  disabled={statusPresentation.kind !== "InStatus"}
                  onClick={async () => {
                    // Use centralized presence change with timeout
                    changeRegularPresence("DND", table.duration);
                  }}
                >
                  <ListItemText
                    className={classes.innerList}
                    primary="Do not disturb"
                  />
                </ListItem>
                {table &&
                  table
                    .filter((myTable: any) => myTable.category === "dnd")
                    .map((myTable: any) => (
                      <ListItem
                        key={myTable.id}
                        button
                        className={lightMode ? style.presenceSelectable : style.presenceSelectableDark}
                        selected={
                          myTable.status === "[custom]"
                            ? user.custom === "DND"
                            : user.display === `DND:${myTable.status}`
                        }
                        disabled={statusPresentation.kind !== "InStatus"}
                        onClick={async () => {
                          // Use centralized presence change with timeout
                          changeCustomPresence("DND", myTable, customDnd);
                        }}
                      >
                        {myTable.duration && (
                          <ListItemIcon style={{ minWidth: 0 }}>
                            <Timer style={{ fontSize: "0.7rem" }} />
                          </ListItemIcon>
                        )}
                        <ListItemText
                          className={classes.innerList}
                          primary={
                            <div>
                              {myTable.status !== "[custom]" && (
                                <span className="notranslate">{myTable.status}</span>
                              )}
                              {myTable.status === "[custom]" && !dndEdit && (
                                <span className="notranslate">{customDnd}</span>
                              )}
                              {myTable.status === "[custom]" && dndEdit && (
                                <TextField
                                  variant="outlined"
                                  autoFocus
                                  value={customDnd}
                                  onChange={(event) => {
                                    setCustomDnd(
                                      event.target.value.replace(":", "")
                                    );
                                  }}
                                  onKeyPress={(event: any) => {
                                    if (event.key === "Enter") {
                                      setDndEdit(!dndEdit);
                                    }
                                  }}
                                  hiddenLabel
                                  size="small"
                                  classes={{ root: [...classes.text, ' notranslate'].join("") }}
                                  style={
                                    mode === "dark" ? { color: "white" } : {}
                                  }
                                />
                              )}
                              {myTable.status === "[custom]" && (
                                <IconButton
                                  color="primary"
                                  component="span"
                                  onClick={(event: any) => {
                                    event.stopPropagation();
                                    setDndEdit(!dndEdit);
                                  }}
                                >
                                  <Edit style={{ fontSize: "0.7rem" }} />
                                </IconButton>
                              )}
                            </div>
                          }
                        />
                      </ListItem>
                    ))}
              </List>
            </Collapse>
            </div>

            {/* INV PRESENCES */}
            <div className={style.presenceCollapseContainer}>
            <ListItem disableRipple button onClick={() => setInvisibleExpand(!invisibleExpand)} className={lightMode ? style.presenceDropdown : style.presenceDropdownDark}>
              <ListItemIcon>
                <Circle style={{ color: "grey" }} />
              </ListItemIcon>
              <ListItemText
                primary="Invisible"
                classes={{ primary: classes.listItemText }}
              />
              {invisibleExpand ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={invisibleExpand} timeout="auto" unmountOnExit >
              <List component="div" disablePadding>
                <ListItem
                  button
                  className={lightMode ? style.presenceSelectable : style.presenceSelectableDark}
                  selected={user.display === "INV:Invisible"}
                  disabled={statusPresentation.kind !== "InStatus"}
                  onClick={async () => {
                    let dndStatus =
                      user.lastDndStatus === "DoNotAcceptAnyCalls"
                        ? "TakeAllCalls"
                        : undefined;

                    if (hasInvisibleCallControl) {
                      const { invisibleCallControl: newCallControl } =
                        await fetch(
                          forwardAddress.replace(
                            "/shadow-agent",
                            `/user/${rcId}`
                          ),
                          {
                            method: "get",
                            headers: {
                              Authorization: idToken,
                            },
                          }
                        ).then((res) => res.json());
                      dndStatus = newCallControl;
                    }
                    // tell RC
                    // window.parent.postMessage(
                    //   JSON.stringify({
                    //     event: "flash-message",
                    //     userStatus: "Offline",
                    //     dndStatus,
                    //     message: "INV:Invisible",
                    //     id: rcId,
                    //   }),
                    //   origin
                    // );
                    // Use centralized presence change with timeout (invisible with dndOverride)
                    changeRegularPresence("INV", table.duration, dndStatus);
                    /*
                    const res = await fetch(
                      `${process.env.REACT_APP_API_URL}/flash`,
                      {
                        method: "POST",
                        body: JSON.stringify({
                          userStatus: "Offline",
                          dndStatus,
                          message: "INV:Invisible",
                          id: rcId,
                          token: rcAccessToken,
                        }),
                        headers: {
                          authorization: idToken || "",
                        },
                      }
                    );
                    if (res.ok) {

                      // tell SA
                      await fetch(apiUrl, {
                        method: "post",
                        headers: {
                          "Content-Type": "application/json",
                        },
                        body: JSON.stringify({
                          event: `/restapi/v1.0/account/${organizationId}/extension/${rcId}/presence`,
                          body: {
                            dndStatus,
                            presenceStatus: "Offline",
                            message: "INV:Invisible",
                          },
                          send: true,
                        }),
                      });
                  }
                      */
                    
                  }}
                >
                  <ListItemText
                    className={classes.innerList}
                    primary="Invisible"
                  />
                </ListItem>
                {table &&
                  table
                    .filter((myTable: any) => myTable.category === "inv")
                    .map((myTable: any) => (
                      <ListItem key={myTable.id} button className={lightMode ? style.presenceSelectable : style.presenceSelectableDark}
                        selected={myTable.status === "[custom]" ? user.custom === "INV" : user.display === `INV:${myTable.status}` }
                        disabled={statusPresentation.kind !== "InStatus"}
                        onClick={
                          async () => {
                          let dndStatus = user.lastDndStatus === "DoNotAcceptAnyCalls" ? "TakeAllCalls" : undefined;
                          if (hasInvisibleCallControl) {
                            const { invisibleCallControl: newCallControl } =
                              await fetch(
                                forwardAddress.replace(
                                  "/shadow-agent",
                                  `/user/${rcId}`
                                ),
                                {
                                  method: "get",
                                  headers: {
                                    Authorization: idToken,
                                  },
                                }
                              ).then((res) => res.json());
                            dndStatus = newCallControl;
                          }

                          // Use centralized presence change with timeout
                          changeCustomPresence("INV", myTable, customInvisible, dndStatus);
                          /*
                          const res = await fetch( `${process.env.REACT_APP_API_URL}/flash`,{
                              method: "POST",
                              body: JSON.stringify({
                                userStatus: "Offline",
                                dndStatus,
                                message: `INV:${myTable.status === "[custom]" ? customInvisible : myTable.status}`,
                                id: rcId,
                                token: rcAccessToken,
                              }),
                              headers: {authorization: idToken || ""},
                            }
                          );
                          if (res.ok) {
                            setTimer({ duration: myTable.duration, id: rcId });
                            setLateTimer(undefined);
                            // tell SA
                            await fetch(apiUrl, {
                              method: "post",
                              headers: {
                                "Content-Type": "application/json",
                              },
                              body: JSON.stringify({
                                event: `/restapi/v1.0/account/${organizationId}/extension/${rcId}/presence`,
                                body: {
                                  dndStatus,
                                  presenceStatus: "Offline",
                                  message: `INV:${myTable.status}`,
                                  custom:
                                    myTable.status === "[custom]"
                                      ? `INV:${customInvisible}`
                                      : undefined,
                                },
                                send: true,
                              }),
                            });
                          }*/
                        }}
                      >
                        {myTable.duration && (
                          <ListItemIcon style={{ minWidth: 0 }}>
                            <Timer style={{ fontSize: "0.7rem" }} />
                          </ListItemIcon>
                        )}
                        <ListItemText
                          className={classes.innerList}
                          primary={
                            <div>
                              {myTable.status !== "[custom]" && (
                                <span className="notranslate">{myTable.status}</span>
                              )}
                              {myTable.status === "[custom]" &&
                                !invisibleEdit && (
                                  <span className="notranslate">{customInvisible}</span>
                                )}
                              {myTable.status === "[custom]" && invisibleEdit && (
                                <TextField
                                  variant="outlined"
                                  autoFocus
                                  value={customInvisible}
                                  onChange={(event) => {
                                    setCustomInvisible(
                                      event.target.value.replace(":", "")
                                    );
                                  }}
                                  onKeyPress={async (event: any) => {
                                    if (event.key === "Enter") { 
                                        setInvisibleEdit(!invisibleEdit);
                                        let dndStatus = user.lastDndStatus === "DoNotAcceptAnyCalls" ? "TakeAllCalls" : undefined;
                                        if (hasInvisibleCallControl) {
                                          const { invisibleCallControl: newCallControl } =
                                            await fetch(
                                              forwardAddress.replace(
                                                "/shadow-agent",
                                                `/user/${rcId}`
                                              ),
                                              {
                                                method: "get",
                                                headers: {
                                                  Authorization: idToken,
                                                },
                                              }
                                            ).then((res) => res.json());
                                          dndStatus = newCallControl;
                                        }
                                        // Use centralized presence change with timeout
                                        changeCustomPresence("INV", myTable, customInvisible, dndStatus);
                                        /*
                                        const res = await fetch( `${process.env.REACT_APP_API_URL}/flash`,{
                                            method: "POST",
                                            body: JSON.stringify({
                                              userStatus: "Offline",
                                              dndStatus,
                                              message: `INV:${myTable.status === "[custom]" ? customInvisible : myTable.status}`,
                                              id: rcId,
                                              token: rcAccessToken,
                                            }),
                                            headers: {authorization: idToken || ""},
                                          }
                                        );
                                        if (res.ok) {
                                          setTimer({ duration: myTable.duration, id: rcId });
                                          setLateTimer(undefined);
                                          // tell SA
                                          await fetch(apiUrl, {
                                            method: "post",
                                            headers: {
                                              "Content-Type": "application/json",
                                            },
                                            body: JSON.stringify({
                                              event: `/restapi/v1.0/account/${organizationId}/extension/${rcId}/presence`,
                                              body: {
                                                dndStatus,
                                                presenceStatus: "Offline",
                                                message: `INV:${myTable.status}`,
                                                custom:
                                                  myTable.status === "[custom]"
                                                    ? `INV:${customInvisible}`
                                                    : undefined,
                                              },
                                              send: true,
                                            }),
                                          });
                                        }*/
                                    }
                                  }}
                                  hiddenLabel
                                  size="small"
                                  classes={{ root: [...classes.text, ' notranslate'].join("") }}
                                  style={
                                    mode === "dark" ? { color: "white" } : {}
                                  }
                                />
                              )}
                              {myTable.status === "[custom]" && (
                                <IconButton
                                  color="primary"
                                  component="span"
                                  onClick={(event: any) => {
                                    event.stopPropagation();
                                    setInvisibleEdit(!invisibleEdit);
                                  }}
                                >
                                  <Edit style={{ fontSize: "0.7rem" }} />
                                </IconButton>
                              )}
                            </div>
                          }
                        />
                      </ListItem>
                    ))}
              </List>
            </Collapse>
            </div>
              </>
            )
           }
            {/* <Divider light /> */}
            {profileTab === "queue-presence" && user && historicalQueues.find((queue: any) => queue.users.find((queueUser: any) => queueUser.id === user.id)) && (
                <div >
                  {/* <ListItem
                    aria-label="Expand available"
                    button
                    style={{ borderRadius: 5}}
                    onClick={() => {
                      setQueuePresenceOpen(!queuePresenceOpen);
                    }}
                  >
                    <ListItemIcon>
                      <PeopleAlt
                        style={{ color: mode === "light" ? "black" : "white" }}
                      />
                    </ListItemIcon>
                    <ListItemText
                      primary="Queue Presence"
                      classes={{ primary: classes.listItemText }}
                    />
                    {queuePresenceOpen ? <ExpandLess /> : <ExpandMore />}
                  </ListItem> */}
             
                    <ListItem className={lightMode ? style.acceptQueueCalls : style.acceptQueueCallsDark}>
                      <ListItemIcon>
                        <Group />
                        {/* {loading === "takeAllCalls" ? <CircularProgress size={24} /> : <Group />} */}
                      </ListItemIcon>
                      <ListItemText primary="Accept Queue Calls" />
                      {acceptQueueLoading && ( <CircularProgress size={24} style={{ marginRight: 8 }}/> )}
                      <IOSSwitch
                        size="small"
                        disabled={user.lastDndStatus === "DoNotAcceptAnyCalls" || user.display?.startsWith("DND")}
                        checked={user.lastDndStatus === "TakeAllCalls"}
                        onClick={async () => {
                          setAcceptQueueLoading(true);
                            if (user.lastDndStatus === "DoNotAcceptAnyCalls") {
                              return;
                            }
                            const newDndStatus = user.lastDndStatus === "TakeAllCalls" ? "DoNotAcceptDepartmentCalls" : "TakeAllCalls";
                            // tell RC
                            const res = await fetch(
                              `${process.env.REACT_APP_API_URL}/flash`,
                              {
                                method: "POST",
                                body: JSON.stringify({
                                  dndStatus: newDndStatus,
                                  id: rcId,
                                  token: rcAccessToken,
                                }),
                                headers: {
                                  authorization: idToken || "",
                                },
                              }
                            );
                            // tell SA
                            if (res.ok) {
                              await fetch(apiUrl, {
                                method: "post",
                                headers: {
                                  "Content-Type": "application/json",
                                },
                                body: JSON.stringify({
                                  event: `/restapi/v1.0/account/${organizationId}/extension/${rcId}/presence`,
                                  body: {
                                    dndStatus: newDndStatus,
                                  },
                                  send: true,
                                }),
                              });
                            }
                          }}
                      />
                    </ListItem>
                    {user && user.display?.startsWith("DND") && (
                        <span className={lightMode ? style.queueHelperText : style.queueHelperTextDark} style={{top: 55}}>
                          You must exit <span style={{color: "#ff4e4e", alignItems: 'center'}}> 
                            <RemoveCircle style={{  fontSize: "0.8rem", paddingLeft: 2, color: "#ff4e4e" }}
                      /> {user.display.substring(4) || "Do Not Disturb" }</span> before you are able to receive queue calls.</span>
                      )}
                    {presenceQueue && (
                      <Collapse 
                      className={lightMode ? style.queueDropdown : style.queueDropdownDark}
                      // in
                      in={user.lastDndStatus === "TakeAllCalls"}
                       >
                        <span className={lightMode ? style.queueHelperText : style.queueHelperTextDark}>Available Queues</span>
                        {Array.from(historicalQueues.values())
                          .filter((queue: any) =>
                            queue.users.find(
                              (queueUser: any) => queueUser.id === user.id
                            )
                          )
                          .map((queue: any) => {
                            const isLoading = queueLoading.has(queue.id);
                            
                            return(
                            <ListItem
                              component="div"
                              key={queue.id}
                              disabled={!queue.editableMemberStatus}
                            >
                              <ListItemText
                                className="notranslate"
                                primary={queue.name}
                                style={
                                  user.lastDndStatus !== "TakeAllCalls"
                                    ? { color: mode === 'light' ? "black" : "white" }
                                    : {}
                                }
                              />
                            {isLoading && queue.editableMemberStatus && <CircularProgress size={24} style={{ marginRight: 8 }}/>}
                              <IOSSwitch
                                size="small"
                                onClick={() => handleAcceptCallsClick(queue)}
                                disabled={
                                  user.lastDndStatus === "DoNotAcceptAnyCalls"
                                }
                                checked={
                                  queue.users.find(
                                    (queueUser: any) => queueUser.id === user.id
                                  ).acceptCurrentQueueCalls
                                }
                              />
                            </ListItem>
                          )})}
                      </Collapse>
                    )}
               
                  {/* <Divider light />
                  {myId.toString() === user?.id?.toString() && (
                    <ListItem
                      component="div"
                      onClick={async () => {
                        localStorage.removeItem("authInfo");
                        window.location.reload();
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      <ListItemText
                        primary="Logout"
                        classes={{ primary: classes.listItemText }}
                      />
                    </ListItem>
                  )} */}
                </div>
              )}
          </List>
        </Grid>
      </Grid>
    </Grid>
    </Container>
  ) :
  (
    <>
      {user && table && (
        <>
          <div style={{ display: "flex", alignItems: "center" }}>
            <img
              aria-label="portrait"
              alt="Icon"
              width="100px"
              height="100px"
              style={{ borderRadius: "50%" }}
              src={
                user.uri
                  ? `${user.uri}?access_token=${rcAccessToken}`
                  : "./default-user-image.ico"
              }
              onError={(e: any) => {
                e.target.src = "./default-user-image.ico";
              }}
            />
            <div style={{ marginLeft: 10 }}>
              <Typography component="h2" className={classes.h2}>
                {user.firstName} {user.lastName}
                {user.id === myId && showHandRaise && (
                  <IconButton size="medium" onClick={raiseHandChange}>
                    <PanTool
                      style={{
                        color: handRaised ? red[500] : color,
                      }}
                    />
                  </IconButton>
                )}
                {user.id !== myId && showHandRaise && handRaised && isAdmin && (
                  <IconButton size="medium" onClick={raiseHandChange}>
                    <PanTool
                      style={{
                        color: red[500],
                      }}
                    />
                  </IconButton>
                )}
              </Typography>
              <Divider light />
              <div>
                <List>
                  <ListItem
                    aria-label="expand status"
                    button
                    onClick={() => {
                      if (editStatus) {
                        return;
                      }
                      setGlobalExpand(!globalExpand);
                    }}
                    className={[...classes.header, ' notranslate'].join("")}
                  >
                    <ListItemIcon
                      style={
                        mode === "dark"
                          ? {
                              color: "white",
                              width: 20,
                              maxWidth: 15,
                              minWidth: 15,
                            }
                          : { width: 20, maxWidth: 15, minWidth: 15}
                      }
                    >
                      <ChatBubble style={{ fontSize: "0.7rem" }} />
                    </ListItemIcon>
                    {!!editStatus && (
                      <TextField
                        variant="outlined"
                        autoFocus
                        value={tempStatus}
                        onChange={(event) => {
                          setTempStatus(event.target.value);
                        }}
                        onKeyPress={(event: any) => {
                          if (event.key === "Enter") {
                            setEditStatus(!editStatus);
                          }
                        }}
                        hiddenLabel
                        size="small"
                        classes={{ root: [...classes.text, " notranslate"].join("") }}
                        style={
                          mode === "dark"
                            ? { color: "white", textAlign: "start" }
                            : { textAlign: "start" }
                        }
                      />
                    )}
                    {!editStatus && <ListItemText primary={user.status} />}
                    {!hideEdit && (
                      <IconButton
                        color="primary"
                        component="span"
                        onClick={(event: any) => {
                          event.stopPropagation();
                          setEditStatus(!editStatus);
                        }}
                      >
                        <Edit style={{ fontSize: "0.7rem" }} />
                      </IconButton>
                    )}
                    {globalExpand ? <ExpandLess /> : <ExpandMore />}
                  </ListItem>
                  <Collapse in={globalExpand} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                      {globalStatuses?.map((myGlobal) => (
                        <ListItem
                          key={myGlobal}
                          button
                          selected={user.status === myGlobal}
                          onClick={() => handleGlobalChange(myGlobal)}
                        >
                          <ListItemText
                            className={[...classes.innerList, " notranslate"].join(" ")}
                            primary={myGlobal}
                          />
                        </ListItem>
                      ))}
                    </List>
                  </Collapse>
                  <ListItem className={classes.header}>
                    {cxAgents && cxAgents.length && (
                      <ListItemIcon>
                        <Tooltip title="EX">
                          <Phone
                            style={{
                              color: mode === "light" ? "black" : "white",
                            }}
                          />
                        </Tooltip>
                      </ListItemIcon>
                    )}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "start",
                      }}
                    >{ /* }
                      <ListItemIcon style={{ minWidth: 14 }}>
                        {(() => {
                          if (
                            user.display === undefined ||
                            user.display.startsWith("AVL")
                          ) {
                            return (
                              <Circle
                                style={{ color: "green", fontSize: "0.8rem" }}
                                aria-label="Available icon"
                                aria-hidden={false}
                                role="img"
                              />
                            );
                          }

                          if (user.display.startsWith("DND")) {
                            return (
                              <RemoveCircle
                                aria-label="Do not disturb icon"
                                aria-hidden={false}
                                role="img"
                                style={{ color: "red", fontSize: "0.7rem" }}
                              />
                            );
                          }

                          if (user.display.startsWith("INV")) {
                            return (
                              <Circle
                                style={{ color: "grey", fontSize: "0.8rem" }}
                                aria-label="Invisible icon"
                                aria-hidden={false}
                                role="img"
                              />
                            );
                          }

                          if (user.display.startsWith("BSY")) {
                            return (
                              <Circle
                                style={{ color: "red", fontSize: "0.8rem" }}
                                aria-label="Busy icon"
                                aria-hidden={false}
                                role="img"
                              />
                            );
                          }

                          return "";
                        })()}
                      </ListItemIcon>
                      <ListItemText className="notranslate"
                        primary={(() => {
                          let timeDisplay = "";

                          if (timer?.duration) {
                            timeDisplay += ` (${Math.floor(
                              parseInt(timer.duration, 10) / 60
                            )}:${(parseInt(timer.duration, 10) % 60)
                              .toString()
                              .padStart(2, "0")})`;
                          }

                          return (
                            (user.display || "").substring(4) + timeDisplay
                          );
                        })()}
                      /> { */ }

<ExPresence 
            accountId={organizationId}
            userId={rcId}
            display={user.display}
            cxUser={!!cxUser?.agentState }
            lightMode={lightMode}
            idToken={idToken}
            statusPresentation={statusPresentation}
            timeElapsed={timeElapsed}
            presenceTimerData={user.timerInfo}
            late={user.late}
            />
                    </div>
                  </ListItem>
                </List>
                {cxAgents &&
                  cxAgents.length &&
                  cxAgents
                    ?.filter((agent) => agent.rcUserId === user.id)
                    ?.map((userCX) => (
                      <ListItem
                        className={classes.header}
                        style={{ height: 19, marginBottom: 10 }}
                      >
                        <div style={{ position: "relative", minWidth: 56 }}>
                          <div style={{ position: "relative" }}>
                            {userCX !== undefined &&
                              userCX.agentState !== undefined && (
                                <div>
                                  <Tooltip title="CX">
                                    <PeopleAlt
                                      style={{
                                        color:
                                          mode === "light" ? "black" : "white",
                                      }}
                                    />
                                  </Tooltip>
                                </div>
                              )}
                          </div>
                        </div>

                        <ListItemText
                          primary={
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "start",
                                alignItems: "center",
                              }}
                            >
                              {(() => {
                                if (userCX.agentState === undefined) {
                                  return "";
                                }
                                if (userCX.agentState === "AVAILABLE") {
                                  return (
                                    <div>
                                      <Circle
                                        style={{
                                          color: "green",
                                          fontSize: "0.8rem",
                                        }}
                                        aria-label="Available icon"
                                        aria-hidden={false}
                                        role="img"
                                      />
                                    </div>
                                  );
                                }
                                if (
                                  userCX.agentState === "TRAINING" ||
                                  userCX.agentState === "WORKING"
                                )
                                  return (
                                    <div>
                                      <Circle
                                        style={{
                                          color: "#f7b500",
                                          fontSize: "0.8rem",
                                        }}
                                        aria-label="busy icon"
                                        aria-hidden={false}
                                        role="img"
                                      />
                                    </div>
                                  );
                                if (
                                  userCX.agentState === "ENGAGED" ||
                                  userCX.agentState === "BREAK-AFTER-CALL" ||
                                  userCX.agentState === "TRANSITION" ||
                                  userCX.agentState === "PENDING-DISPOSITION" ||
                                  userCX.agentState === "RNA-STATE" ||
                                  userCX.agentState === "TRAINING" ||
                                  userCX.agentState === "WORKING"
                                ) {
                                  return (
                                    <div>
                                      <Circle
                                        style={{
                                          color: "red",
                                          fontSize: "0.8rem",
                                        }}
                                        aria-label="Busy icon"
                                        aria-hidden={false}
                                        role="img"
                                      />
                                    </div>
                                  );
                                }

                                if (
                                  userCX.agentState === "OFF-LINE" ||
                                  userCX.agentState === "UNKNOWN" ||
                                  userCX.agentState === "AWAY" ||
                                  userCX.agentState === "LUNCH" ||
                                  userCX.agentState === "ON-BREAK"
                                ) {
                                  return (
                                    <div>
                                      <Circle
                                        style={{
                                          color: "grey",
                                          fontSize: "0.8rem",
                                        }}
                                        aria-label="Invisible icon"
                                        aria-hidden={false}
                                        role="img"
                                      />
                                    </div>
                                  );
                                }

                                return "";
                              })()}
                              {userCX.agentState}
                            </div>
                          }
                        />
                      </ListItem>
                    ))}
              </div>
            </div>
          </div>
        </>
      )}
      <Grid container spacing={0}>
        <Grid item sm={6} xs={12}>
          <Divider light />
          <List>
            <ListItem
              aria-label="Expand available"
              button
              onClick={() => {
                setAvailableExpand(!availableExpand);
              }}
            >
              <ListItemIcon>
                <Circle style={{ color: "green" }} />
              </ListItemIcon>
              <ListItemText
                primary="Available"
              />
              {availableExpand ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={availableExpand} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItem
                  aria-label="Select available status"
                  button
                  selected={user.display === "AVL:Available"}
                  disabled={statusPresentation.kind !== "InStatus"}
                  onClick={async () => {
                    // Use centralized presence change with timeout
                    changeRegularPresence("AVL", table.duration);
                  }}
                >
                  <ListItemText
                    className={classes.innerList}
                    primary="Available"
                  />
                </ListItem>
                {table &&
                  table
                    .filter((myTable: any) => myTable.category === "avl")
                    .map((myTable: any) => (
                      <ListItem
                        key={myTable.id}
                        button
                        selected={
                          myTable.status === "[custom]"
                            ? user.custom === "AVL"
                            : user.display === `AVL:${myTable.status}`
                        }
                        disabled={statusPresentation.kind !== "InStatus"}
                        onClick={async () => {
                          // Use centralized presence change with timeout
                          changeCustomPresence("AVL", myTable, customAvailable);
                        }}
                      >
                        {myTable.duration && (
                          <ListItemIcon style={{ minWidth: 0 }}>
                            <Timer style={{ fontSize: "0.7rem" }} />
                          </ListItemIcon>
                        )}
                        <ListItemText
                          className={[...classes.innerList, " notranslate"].join("")}
                          primary={
                            <div className="notranslate">
                              {myTable.status !== "[custom]" && (
                                <span className="notranslate">{myTable.status}</span>
                              )}
                              {myTable.status === "[custom]" &&
                                !availableEdit && (
                                  <span className="notranslate">{customAvailable}</span>
                                )}
                              {myTable.status === "[custom]" && availableEdit && (
                                <TextField
                                  variant="outlined"
                                  autoFocus
                                  className="notranslate"
                                  value={customAvailable}
                                  onChange={(event) => {
                                    setCustomAvailable(
                                      event.target.value
                                        .replace(":", "")
                                        .slice(0, 30)
                                    );
                                  }}
                                  onKeyPress={(event: any) => {
                                    if (event.key === "Enter") {
                                      setAvailableEdit(!availableEdit);
                                    }
                                  }}
                                  hiddenLabel
                                  size="small"
                                  classes={{ root: [...classes.text, ' notranslate'].join("") }}
                                  style={
                                    mode === "dark" ? { color: "white" } : {}
                                  }
                                />
                              )}
                              {myTable.status === "[custom]" && (
                                <IconButton
                                  color="primary"
                                  component="span"
                                  onClick={(event: any) => {
                                    event.stopPropagation();
                                    setAvailableEdit(!availableEdit);
                                  }}
                                >
                                  <Edit style={{ fontSize: "0.7rem" }} />
                                </IconButton>
                              )}
                            </div>
                          }
                        />
                      </ListItem>
                    ))}
              </List>
            </Collapse>
            <Divider light />
            <ListItem
              button
              onClick={() => {
                setBusyExpand(!busyExpand);
              }}
            >
              <ListItemIcon>
                <Circle style={{ color: "red" }} />
              </ListItemIcon>
              <ListItemText
                primary="Busy"
                classes={{ primary: classes.listItemText }}
              />
              {busyExpand ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={busyExpand} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItem
                  button
                  selected={user.display === "BSY:Busy"}
                  disabled={statusPresentation.kind !== "InStatus"}
                  onClick={async () => {
                    // Use centralized presence change with timeout
                    changeRegularPresence("BSY", table.duration);
                  }}
                >
                  <ListItemText className={classes.innerList} primary="Busy" />
                </ListItem>
                {table &&
                  table
                    .filter((myTable: any) => myTable.category === "bus")
                    .map((myTable: any) => (
                      <ListItem
                        key={myTable.id}
                        button
                        selected={
                          myTable.status === "[custom]"
                            ? user.custom === "BSY"
                            : user.display === `BSY:${myTable.status}`
                        }
                        disabled={statusPresentation.kind !== "InStatus"}
                        onClick={async () => {
                          // Use centralized presence change with timeout
                          changeCustomPresence("BSY", myTable, customBusy);
                        }}
                      >
                        {myTable.duration && (
                          <ListItemIcon style={{ minWidth: 0 }}>
                            <Timer style={{ fontSize: "0.7rem" }} />
                          </ListItemIcon>
                        )}
                        <ListItemText
                          className={[...classes.innerList, ' notranslate'].join("")}
                          primary={
                            <div className="notranslate">
                              {myTable.status !== "[custom]" && (
                                <span className="notranslate">{myTable.status}</span>
                              )}
                              {myTable.status === "[custom]" && !busyEdit && (
                                <span className="notranslate">{customBusy}</span>
                              )}
                              {myTable.status === "[custom]" && busyEdit && (
                                <TextField
                                  variant="outlined"
                                  autoFocus
                                  value={customBusy}
                                  onChange={(event) => {
                                    setCustomBusy(
                                      event.target.value.replace(":", "")
                                    );
                                  }}
                                  onKeyPress={(event: any) => {
                                    if (event.key === "Enter") {
                                      setBusyEdit(!busyEdit);
                                    }
                                  }}
                                  hiddenLabel
                                  size="small"
                                  classes={{ root: [...classes.text, ' notranslate'].join("") }}
                                  style={
                                    mode === "dark" ? { color: "white" } : {}
                                  }
                                />
                              )}
                              {myTable.status === "[custom]" && (
                                <IconButton
                                  color="primary"
                                  component="span"
                                  onClick={(event: any) => {
                                    event.stopPropagation();
                                    setBusyEdit(!busyEdit);
                                  }}
                                >
                                  <Edit style={{ fontSize: "0.7rem" }} />
                                </IconButton>
                              )}
                            </div>
                          }
                        />
                      </ListItem>
                    ))}
              </List>
            </Collapse>
            <Divider light />
            <ListItem
              button
              onClick={() => {
                setDndExpand(!dndExpand);
              }}
            >
              <ListItemIcon>
                <RemoveCircle
                  style={{ color: "red", fontSize: "1.2rem", paddingLeft: 2 }}
                />
              </ListItemIcon>
              <ListItemText
                primary="Do not disturb"
                classes={{ primary: classes.listItemText }}
              />
              {dndExpand ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={dndExpand} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItem
                  button
                  selected={user.display === "DND:Do not disturb"}
                  disabled={statusPresentation.kind !== "InStatus"}
                  onClick={async () => {
                    // Use centralized presence change with timeout
                    changeRegularPresence("DND", table.duration);
                  }}
                >
                  <ListItemText
                    className={classes.innerList}
                    primary="Do not disturb"
                  />
                </ListItem>
                {table &&
                  table
                    .filter((myTable: any) => myTable.category === "dnd")
                    .map((myTable: any) => (
                      <ListItem
                        key={myTable.id}
                        button
                        selected={
                          myTable.status === "[custom]"
                            ? user.custom === "DND"
                            : user.display === `DND:${myTable.status}`
                        }
                        disabled={statusPresentation.kind !== "InStatus"}
                        onClick={async () => {
                          // Use centralized presence change with timeout
                          changeCustomPresence("DND", myTable, customDnd);
                        }}
                      >
                        {myTable.duration && (
                          <ListItemIcon style={{ minWidth: 0 }}>
                            <Timer style={{ fontSize: "0.7rem" }} />
                          </ListItemIcon>
                        )}
                        <ListItemText
                          className={classes.innerList}
                          primary={
                            <div>
                              {myTable.status !== "[custom]" && (
                                <span className="notranslate">{myTable.status}</span>
                              )}
                              {myTable.status === "[custom]" && !dndEdit && (
                                <span className="notranslate">{customDnd}</span>
                              )}
                              {myTable.status === "[custom]" && dndEdit && (
                                <TextField
                                  variant="outlined"
                                  autoFocus
                                  value={customDnd}
                                  onChange={(event) => {
                                    setCustomDnd(
                                      event.target.value.replace(":", "")
                                    );
                                  }}
                                  onKeyPress={(event: any) => {
                                    if (event.key === "Enter") {
                                      setDndEdit(!dndEdit);
                                    }
                                  }}
                                  hiddenLabel
                                  size="small"
                                  classes={{ root: [...classes.text, ' notranslate'].join("") }}
                                  style={
                                    mode === "dark" ? { color: "white" } : {}
                                  }
                                />
                              )}
                              {myTable.status === "[custom]" && (
                                <IconButton
                                  color="primary"
                                  component="span"
                                  onClick={(event: any) => {
                                    event.stopPropagation();
                                    setDndEdit(!dndEdit);
                                  }}
                                >
                                  <Edit style={{ fontSize: "0.7rem" }} />
                                </IconButton>
                              )}
                            </div>
                          }
                        />
                      </ListItem>
                    ))}
              </List>
            </Collapse>
            <Divider light />
            <ListItem
              button
              onClick={() => {
                setInvisibleExpand(!invisibleExpand);
              }}
            >
              <ListItemIcon>
                <Circle style={{ color: "grey" }} />
              </ListItemIcon>
              <ListItemText
                primary="Invisible"
                classes={{ primary: classes.listItemText }}
              />
              {invisibleExpand ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={invisibleExpand} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItem
                  button
                  selected={user.display === "INV:Invisible"}
                  disabled={statusPresentation.kind !== "InStatus"}
                  onClick={async () => {
                    let dndStatus =
                      user.lastDndStatus === "DoNotAcceptAnyCalls"
                        ? "TakeAllCalls"
                        : undefined;

                    if (hasInvisibleCallControl) {
                      const { invisibleCallControl: newCallControl } =
                        await fetch(
                          forwardAddress.replace(
                            "/shadow-agent",
                            `/user/${rcId}`
                          ),
                          {
                            method: "get",
                            headers: {
                              Authorization: idToken,
                            },
                          }
                        ).then((res) => res.json());
                      dndStatus = newCallControl;
                    }

                    // Use centralized presence change with timeout
                    changeRegularPresence("INV", table.duration, dndStatus);
                  }}
                >
                  <ListItemText
                    className={classes.innerList}
                    primary="Invisible"
                  />
                </ListItem>
                {table &&
                  table
                    .filter((myTable: any) => myTable.category === "inv")
                    .map((myTable: any) => (
                      <ListItem
                        key={myTable.id}
                        button
                        selected={
                          myTable.status === "[custom]"
                            ? user.custom === "INV"
                            : user.display === `INV:${myTable.status}`
                        }
                        disabled={statusPresentation.kind !== "InStatus"}
                        onClick={
                          async () => {
                          let dndStatus = user.lastDndStatus === "DoNotAcceptAnyCalls" ? "TakeAllCalls" : undefined;
                          if (hasInvisibleCallControl) {
                            const { invisibleCallControl: newCallControl } =
                              await fetch(
                                forwardAddress.replace(
                                  "/shadow-agent",
                                  `/user/${rcId}`
                                ),
                                {
                                  method: "get",
                                  headers: {
                                    Authorization: idToken,
                                  },
                                }
                              ).then((res) => res.json());
                            dndStatus = newCallControl;
                          }

                          // Use centralized presence change with timeout
                          changeCustomPresence("INV", myTable, customInvisible, dndStatus);
                        }}
                      >
                        {myTable.duration && (
                          <ListItemIcon style={{ minWidth: 0 }}>
                            <Timer style={{ fontSize: "0.7rem" }} />
                          </ListItemIcon>
                        )}
                        <ListItemText
                          className={classes.innerList}
                          primary={
                            <div>
                              {myTable.status !== "[custom]" && (
                                <span className="notranslate">{myTable.status}</span>
                              )}
                              {myTable.status === "[custom]" &&
                                !invisibleEdit && (
                                  <span className="notranslate">{customInvisible}</span>
                                )}
                              {myTable.status === "[custom]" && invisibleEdit && (
                                <TextField
                                  variant="outlined"
                                  autoFocus
                                  value={customInvisible}
                                  onChange={(event) => {
                                    setCustomInvisible(
                                      event.target.value.replace(":", "")
                                    );
                                  }}
                                  onKeyPress={(event: any) => {
                                    if (event.key === "Enter") {
                                      setInvisibleEdit(!invisibleEdit);
                                    }
                                  }}
                                  hiddenLabel
                                  size="small"
                                  classes={{ root: [...classes.text, ' notranslate'].join("") }}
                                  style={
                                    mode === "dark" ? { color: "white" } : {}
                                  }
                                />
                              )}
                              {myTable.status === "[custom]" && (
                                <IconButton
                                  color="primary"
                                  component="span"
                                  onClick={(event: any) => {
                                    event.stopPropagation();
                                    setInvisibleEdit(!invisibleEdit);
                                  }}
                                >
                                  <Edit style={{ fontSize: "0.7rem" }} />
                                </IconButton>
                              )}
                            </div>
                          }
                        />
                      </ListItem>
                    ))}
              </List>
            </Collapse>
            <Divider light />
            {user &&
              historicalQueues.find((queue: any) =>
                queue.users.find((queueUser: any) => queueUser.id === user.id)
              ) && (
                <>
                  <ListItem
                    aria-label="Expand available"
                    button
                    onClick={() => {
                      setQueuePresenceOpen(!queuePresenceOpen);
                    }}
                  >
                    <ListItemIcon>
                      <PeopleAlt
                        style={{ color: mode === "light" ? "black" : "white" }}
                      />
                    </ListItemIcon>
                    <ListItemText
                      primary="Queue Presence"
                      classes={{ primary: classes.listItemText }}
                    />
                    {queuePresenceOpen ? <ExpandLess /> : <ExpandMore />}
                  </ListItem>
                  <Collapse in={queuePresenceOpen}>
                    <ListItem
                      component="div"
                      onClick={async () => {
                        if (user.lastDndStatus === "DoNotAcceptAnyCalls") {
                          return;
                        }

                        const newDndStatus =
                          user.lastDndStatus === "TakeAllCalls"
                            ? "DoNotAcceptDepartmentCalls"
                            : "TakeAllCalls";

                        // tell RC
                        const res = await fetch(
                          `${process.env.REACT_APP_API_URL}/flash`,
                          {
                            method: "POST",
                            body: JSON.stringify({
                              dndStatus: newDndStatus,
                              id: rcId,
                              token: rcAccessToken,
                            }),
                            headers: {
                              authorization: idToken || "",
                            },
                          }
                        );
                        // tell SA
                        if (res.ok) {
                          await fetch(apiUrl, {
                            method: "post",
                            headers: {
                              "Content-Type": "application/json",
                            },
                            body: JSON.stringify({
                              event: `/restapi/v1.0/account/${organizationId}/extension/${rcId}/presence`,
                              body: {
                                dndStatus: newDndStatus,
                              },
                              send: true,
                            }),
                          });
                        }
                      }}
                    >
                      <ListItemText
                        primary="Accept Queue Calls"
                        classes={{ primary: classes.innerList }}
                        style={{ marginLeft: -30 }}
                      />
                                            {acceptQueueLoading && ( <CircularProgress size={24} style={{ marginRight: 8 }}/> )}
                      <Switch
                       classes={{
                        switchBase: classes.switchBase,
                        checked: classes.checked,
                        track: classes.track,
                      }}  
                        size="small"
                        disabled={user.lastDndStatus === "DoNotAcceptAnyCalls"}
                        checked={user.lastDndStatus === "TakeAllCalls"}
                        onClick={async () => {
                          setAcceptQueueLoading(true);
                            if (user.lastDndStatus === "DoNotAcceptAnyCalls") {
                              return;
                            }
                            const newDndStatus = user.lastDndStatus === "TakeAllCalls" ? "DoNotAcceptDepartmentCalls" : "TakeAllCalls";
                            // tell RC
                            const res = await fetch(
                              `${process.env.REACT_APP_API_URL}/flash`,
                              {
                                method: "POST",
                                body: JSON.stringify({
                                  dndStatus: newDndStatus,
                                  id: rcId,
                                  token: rcAccessToken,
                                }),
                                headers: {
                                  authorization: idToken || "",
                                },
                              }
                            );
                            // tell SA
                            if (res.ok) {
                              await fetch(apiUrl, {
                                method: "post",
                                headers: {
                                  "Content-Type": "application/json",
                                },
                                body: JSON.stringify({
                                  event: `/restapi/v1.0/account/${organizationId}/extension/${rcId}/presence`,
                                  body: {
                                    dndStatus: newDndStatus,
                                  },
                                  send: true,
                                }),
                              });
                            }
                          }}
                      />
                    </ListItem>
                    {presenceQueue && (
                      <List component="div" disablePadding>
                        {Array.from(historicalQueues.values())
                          .filter((queue: any) =>
                            queue.users.find(
                              (queueUser: any) => queueUser.id === user.id
                            )
                          )
                          .map((queue: any) => {
                            const isLoading = queueLoading.has(queue.id);
                            /*
                            <Tooltip
                              title="You do not have permission from RingCentral to change your status in this queue. 
                              To modify this log into your service.ringcentral.com account. Navigate to Phone System > Groups > Call Queues. 
                              Select this queue, then go to 'Call Handling & Members' then ensure 'Allow members to change their queue status' 
                              to be set to"
                              disableHoverListener={!(!queue.editableMemberStatus)}
                              placement="top"
                            >*/
                            return(
                            <ListItem
                              component="div"
                              key={queue.id}
                              disabled={!queue.editableMemberStatus}
                            >
                              <ListItemText
                                className={[...classes.innerList, " notranslate"].join("")}
                                primary={queue.name}
                                style={
                                  user.lastDndStatus !== "TakeAllCalls"
                                    ? { color: mode === 'light' ? "black" : "white" }
                                    : {}
                                }
                              />
                              {isLoading && queue.editableMemberStatus && <CircularProgress size={24} style={{ marginRight: 8 }}/>}
                              <Switch
                                 classes={{
                                  switchBase: classes.switchBase,
                                  checked: classes.checked,
                                  track: classes.track,
                                }}
                                size="small"
                                onClick={() => handleAcceptCallsClick(queue)}
                                disabled={
                                  user.lastDndStatus === "DoNotAcceptAnyCalls"
                                }
                                checked={
                                  queue.users.find(
                                    (queueUser: any) => queueUser.id === user.id
                                  ).acceptCurrentQueueCalls
                                }
                              />
                            </ListItem>
                          )})}
                      </List>
                    )}
                  </Collapse>
                  <Divider light />
                  <ListItem
                    button
                    onClick={() => {
                      setUserDetail(!userDetail);
                    }}
                  >
                    <ListItemText
                      primary="User details"
                      classes={{ primary: classes.listItemText }}
                    />
                    {userDetail ? <ExpandLess /> : <ExpandMore />}
                  </ListItem>
                <Collapse in={userDetail} timeout="auto" unmountOnExit>
                <ListItem>
                  <ListItemText
                    primary={
                      <>
                        Email: {user?.email ? <span className="notranslate">{user.email}</span> : "-----"}
                      </>
                    }
                    classes={{ primary: classes.userDetails }}
                  />
                </ListItem>
                <ListItem>
                  <ListItemText
                    primary={
                      <>
                        Title: {user?.jobTitle ? <span className="notranslate">{user.jobTitle}</span> : "-----"}
                      </>
                    }
                    classes={{ primary: classes.userDetails }}
                  />
                </ListItem>
                <ListItem>
                  <ListItemText
                    primary={
                      <>
                        Department: {user?.department ? <span className="notranslate">{user.department}</span> : "-----"}
                      </>
                    }
                    classes={{ primary: classes.userDetails }}
                  />
                </ListItem>
                <ListItem>
                  <ListItemText
                    primary={
                      <>
                        Location: {user?.location ? <span className="notranslate">{user.location}</span> : "-----"}
                      </>
                    }
                    classes={{ primary: classes.userDetails }}
                  />
                </ListItem>
                  </Collapse>
                  <Divider light />
                  {myId.toString() === user?.id?.toString() && (
                    <ListItem
                      component="div"
                      onClick={async () => {
                        await deleteCookie();
                        window.location.reload();
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      <ListItemText
                        primary="Sign out of Shadow Agent"
                        classes={{ primary: classes.listItemText }}
                      />
                    </ListItem>
                  )}
                </>
              )}
          </List>
        </Grid>
      </Grid>
    </>
  );
}

export default Profile;
